import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Spin } from 'antd'
import TournamentIntro from './TournamentIntro'
import Cups from './Cups'
import TournamentInstagramVideos from './TournamentInstagramVideos'
import TournamentGroupPhoto from './TournamentGroupPhoto'
import { useApiQuery } from '../../hooks/useApiQuery'
import { TournamentDTO } from '../../types/tournaments'
import { isUpcomingTournament, isPastTournament } from '../../utils/tournamentUtils'
import './TournamentModule.css'

const TournamentModule: React.FC = () => {
    const { i18n } = useTranslation()
    
    // Convert language format from "en-US"/"de-DE" to "en_EN"/"de_DE"
    // Memoize to prevent recalculation on every render
    const languageParam = useMemo(() => {
        const [lang, country] = i18n.language.split('-')
        return `${lang.toLowerCase()}_${country.toUpperCase()}`
    }, [i18n.language])
    
    // Memoize endpoint to prevent recreation on every render
    const endpoint = useMemo(
        () => `website/tournaments?language=${languageParam}`,
        [languageParam]
    )
    
    // Memoize queryKey to prevent array recreation on every render
    const queryKey = useMemo(() => [i18n.language], [i18n.language])
    
    const { data: tournaments, isPending } = useApiQuery<TournamentDTO[]>({
        endpoint,
        queryKey,
    })

    // Filter tournaments before passing to Cups component
    const upcomingTournaments = tournaments
        ? tournaments.filter(isUpcomingTournament)
        : []
    const pastTournaments = tournaments
        ? tournaments.filter(isPastTournament)
        : []

    return (
        <div className="main-content tournament-wrapper">
            <TournamentIntro />
            {isPending ? (
                <div className="tournament-loading-container">
                    <Spin size="large" />
                </div>
            ) : (
                <>
                    <Cups tournaments={upcomingTournaments} type="upcoming" />
                    <Cups tournaments={pastTournaments} type="past" />
                </>
            )}
            <TournamentInstagramVideos />
            <TournamentGroupPhoto />
        </div>
    )
}

export default TournamentModule
